"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CriticalAcclaim() {
  const testimonials = [{
    quote: "Rivers possesses a rare, quiet intensity that commands the frame. He doesn't just play a role; he inhabits the silence between the lines.",
    name: "Elena Vance",
    title: "Director",
    establishment: "NOIR CINEMA COLLECTIVE"
  }, {
    quote: "A master of physical storytelling. His performance in 'The Glass Menagerie' was a masterclass in vulnerability and stage presence.",
    name: "Marcus Thorne",
    title: "Theater Critic",
    establishment: "THE STAGE REVIEW"
  }, {
    quote: "Jordan brings a cinematic gravity to every project. His range from classical Shakespeare to gritty modern drama is truly exceptional.",
    name: "Sarah Jenkins",
    title: "Casting Director",
    establishment: "METRO CASTING"
  }, {
    quote: "The camera loves him, but the audience trusts him. He is the definitive protagonist for the modern noir era.",
    name: "Julian Rossi",
    title: "Producer",
    establishment: "SILVER SCREEN STUDIOS"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  return <section data-section-id="3847" id="critical-acclaim" className="bg-background text-foreground py-32 px-6 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, hsl(0 0% 85% / 0.03) 0%, transparent 60%)"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative mx-auto max-w-[900px] text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}

        {}
        <div className="relative min-h-[420px] md:min-h-[380px]">
          {testimonials.map((t, i) => <div key={i} data-index={i} className={`absolute inset-0 transition-opacity duration-[800ms] ease-in-out ${activeIndex === i ? "opacity-100" : "opacity-0 pointer-events-none"}`} aria-hidden={activeIndex !== i}>
              {}
              <div className="font-default font-light leading-none select-none absolute -top-4 md:-top-8 left-0 md:left-8 opacity-20" style={{
            fontSize: "clamp(8rem, 14vw, 12rem)",
            color: "var(--foreground)",
            lineHeight: 0.8
          }} aria-hidden="true">
                &ldquo;
              </div>

              {}
              <blockquote className="font-default italic relative z-10 pt-16 md:pt-20" style={{
            fontSize: "clamp(1.75rem, 3.5vw, 2.75rem)",
            lineHeight: 1.2,
            color: "var(--foreground)"
          }}>
                {t.quote}
              </blockquote>

              {}
              <div className="flex justify-center mt-12 mb-8">
                <span className="block h-px w-[60px]" style={{
              backgroundColor: "var(--border)"
            }} />
              </div>

              {}
              <div className="space-y-2">
                <p className="font-default font-semibold" style={{
              fontSize: "1.25rem",
              color: "var(--foreground)"
            }}>
                  {t.name}
                </p>
                <p className="font-default italic" style={{
              color: "var(--muted-foreground)"
            }}>
                  {t.title}
                </p>
                <p className="font-mono text-xs tracking-[0.1em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                  {t.establishment}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className="flex justify-center items-center gap-3 mt-20 relative z-10">
          {testimonials.map((_, i) => <button key={i} data-index={i} onClick={() => setActiveIndex(i)} aria-label={`View reflection ${i + 1}`} className="group h-px transition-all duration-500 ease-out cursor-pointer" style={{
          width: activeIndex === i ? "40px" : "20px",
          backgroundColor: activeIndex === i ? "var(--primary)" : "var(--border)"
        }} />)}
        </div>
      </div>
    </section>;
}